import React from "react";
import { connect } from "react-redux";

import { AvatarIcon } from "Components";
import { Chip, Avatar } from "@material-ui/core";

import styles from "./styles";

function Members({ open, users }) {

  const classes = styles();

  users.sort((a, b) => a.offline > b.offline);
  //console.log("users : ", users)

  return (
    <div className={classes.membersRoot}>
      {users.flatMap((user, index, arr) => {
        let res;
        if (user !== undefined) {
          res = [
            <Chip className={classes.chipUser}
              key={user.uid}
              label={user.pseudo}
              color={user.offline ? "default" : "primary"}
              avatar={<Avatar><AvatarIcon userUid={user.uid} /></Avatar>}
            />
          ];
          if (index < arr.length - 1) {
            res.push(<div key={user.uid + "divider"} className={classes.divider} />);
          }
        }
        else { //si un utilisateur a été supprimé
          res = [];
        }
        return res;
      })}
    </div>
  );
}

export default connect((state, { chatUid }) => {
  let chats = state.list.chat || {};
  let chat = chats[chatUid] || {};
  let userUids = [];
  if (chat.users && chat.users.length) {
    userUids = chat.users || [];
  } else {
    let groups = state.list.group || {};
    let group = Object.values(groups).find(g => g.chat.includes(chatUid));
    if (group) {
      let { members } = group;
      //console.log('members : ', members)
      userUids = members
        .filter(memberUid => memberUid in state.list.member)
        .map(memberUid => state.list.member[memberUid].user);
    } else {
      // project chat;
      let pros = state.list.project || {};
      let pro = Object.values(pros).find(g => g.chat.includes(chatUid));
      let { users } = pro;
      //console.log("users : ", users)
      //console.log("state.list.member:",state.list.member)
      userUids = users;
    }
  }
  return {
    users: userUids.map(uid => state.list.user[uid])
  };
})(Members);
